import { Head } from '@inertiajs/inertia-vue3';
import Layout from '@/Shared/Layout';
import { Link } from '@inertiajs/inertia-vue3';
import * as am5 from "@amcharts/amcharts5";
import * as am5hierarchy from "@amcharts/amcharts5/hierarchy";
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';
export default {
  components: {
    Head: Head,
    Link: Link
  },
  layout: Layout,
  props: {
    userList: {
      type: Object,
      "default": {}
    }
  },
  mounted: function mounted() {
    this.createTree();
  },
  data: function data() {
    return {};
  },
  methods: {
    createTree: function createTree() {
      am5.array.each(am5.registry.rootElements, function (root) {
        root.dispose();
      });
      var root = am5.Root["new"](this.$refs["chartDiv"]);
      root.setThemes([am5themes_Animated["new"](root)]);
      var data = this.userList;
      var zoomableContainer = root.container.children.push(am5.ZoomableContainer["new"](root, {
        width: am5.p100,
        height: am5.p100,
        wheelable: true,
        pinchZoom: true
      }));
      var zoomTools = zoomableContainer.children.push(am5.ZoomTools["new"](root, {
        target: zoomableContainer
      }));

      // Create series
      // https://www.amcharts.com/docs/v5/charts/hierarchy/#Adding
      var series = zoomableContainer.contents.children.push(am5hierarchy.ForceDirected["new"](root, {
        maskContent: false,
        //!important with zoomable containers
        singleBranchOnly: false,
        downDepth: 2,
        topDepth: 1,
        initialDepth: 3,
        valueField: "value",
        categoryField: "name",
        childDataField: "children",
        idField: "name",
        linkWithField: "linkWith",
        manyBodyStrength: -10,
        centerStrength: 0.8
      }));
      series.get("colors").setAll({
        step: 2
      });
      series.links.template.set("strength", 0.5);
      series.labels.template.set("minScale", 0);
      series.data.setAll([data]);
      series.set("selectedDataItem", series.dataItems[0]);

      // Make stuff animate on load
      series.appear(1000, 100);
    }
  }
};